module.exports = __webpack_public_path__ + "img/levelup-manager.8af32069.svg";